import React, { useState } from 'react'
import Box from '@mui/material/Box'
import LogoAfr from '../../images/logo-afr.svg'
import Cookies from 'js-cookie'
import FormLabel from '@mui/material/FormLabel'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiCard from '@mui/material/Card'
import { Button, TextField, Link, CircularProgress } from '@material-ui/core'
import { styled } from '@mui/material/styles'
import ForgotPassword from './forgot-password'
import { customTheme } from '../../styling'
import axios from '../../axios'
import moment from 'moment'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'


const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}))

const SignInContainer = styled(Stack)(({ theme }) => ({
  backgroundColor:'white',
  height:'100vh',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    // backgroundImage:
    //   'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    // backgroundRepeat: 'no-repeat',
    // ...theme.applyStyles('dark', {
    //   backgroundImage:
    //     'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    // }),
  },
}))

const Login = () => {
  const history = useHistory()
  const [loggingIn, setLoggingIn] = useState(false)
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [loginError, setLoginError] = useState('')
  const [openForgotPassword, setOpenForgotPassword] = useState(false)

  const handleClose = () => {
    setOpenForgotPassword(false)
  }
  const handleClickOpen= () => {
    setOpenForgotPassword(true)

  }
  const handleLoginRequest = async ({email, password}) => {
    const userCreds =  await axios.post('/login', {
      username: email,
      password,
    })
    return userCreds
    
  }
  const handleLogin = async () => {
    setLoggingIn(true)
    handleLoginRequest({email, password}).then((res) => {
      setLoggingIn(false)
      console.log('res.data.token', res.data.token)
      localStorage.setItem('afr-portale-authorization-token', res.data.token)
      history.push('/dashboard')
      
    }).catch((error) => {
      console.log(error)
      if(error.status === 400){
        setLoginError(error.response.data.message)
      }
      setLoggingIn(false)
    })
  }

  return (
    <Box>
      {/* <CssBaseline enableColorScheme /> */}
      
      <SignInContainer direction="column" justifyContent="space-between">
        <img src={LogoAfr} style={{ height: '9vh', position:'relative',  top:'19%' }} />
        <Card variant="outlined">
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)', color:'black'}}
          >
            Login
          </Typography>
          <Box
            
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            
              <FormLabel htmlFor="email">Email o Nome Azienda</FormLabel>
              <TextField
            
                id="email"
                type="email"
                name="email"
                placeholder="your@email.com"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                onChange={(event) => setEmail(event.target.value)}
                
                sx={{ ariaLabel: 'email' }}
              />
            
            
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel htmlFor="password">Password</FormLabel>
              </Box>
              <TextField
                error={loginError}
                helperText={loginError}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                autoFocus
                required
                fullWidth
                variant="outlined"
                onChange={(event) => setPassword(event.target.value)}
                color='primary'
                
              />
            <ForgotPassword open={openForgotPassword} handleClose={handleClose} />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color='primary'
              onClick={() => handleLogin()}
            >
              {loggingIn ? <CircularProgress size={25} color='white' /> : 'Login'}
            </Button>
          </Box>
          
          
        </Card>
      </SignInContainer>
    </Box>
  )
}

export default Login